/** @format */

import React, { useState, useEffect } from "react";
// Table
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationTotalStandalone,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit";

import SearchTable from "components/search/SearchTable";
import { columns } from "components/columns/CustomerService/CustomerNoticeColumns";
import { projectFirestore } from "components/ProjectFirestore";

const Notice = () => {
  const [datas, setDatas] = useState([]);

  useEffect(async () => {
    try {
      const collectionRef = projectFirestore.collection("customerService").doc("notice").collection("items");
      const tempDatas = [];

      const collectionValue = await collectionRef.orderBy("createdAt", "desc").get();
      collectionValue.forEach((doc) => {
        tempDatas.push({ ...doc.data(), id: doc.id });
      });
      setDatas(tempDatas);
    } catch (error) {
      console.error(error);
    }
  }, []);

  return (
    <div className="border-table">
      <ToolkitProvider keyField="id" bootstrap4 data={datas} columns={columns} search>
        {(props) => (
          <div>
            {/* search table */}
            <div className="w-full">
              <SearchTable props={props} size={"col-md-12"} />
            </div>
            <PaginationProvider
              pagination={paginationFactory({
                custom: true,
                totalSize: datas ? datas.length : 0,
              })}
            >
              {({ paginationProps, paginationTableProps }) => (
                <div className="p-3">
                  <BootstrapTable
                    keyField="id"
                    data={datas}
                    columns={columns}
                    noDataIndication=" "
                    {...paginationTableProps}
                    {...props.baseProps}
                    wrapperClasses="table-responsive"
                    classes="mytable-hover2 border-table"
                    rowClasses="mytable-hover-row2"
                    expandRow={{
                      showExpandColumn: true,
                      expandColumnPosition: "right",
                      expandHeaderColumnRenderer: ({ isAnyExpands }) => {
                        if (isAnyExpands) {
                          return <b className="cursor-pointer border py-1 px-2 rounded-full">-</b>;
                        }
                        return <b className="cursor-pointer border py-1 px-2 rounded-full">+</b>;
                      },
                      expandColumnRenderer: ({ expanded }) => {
                        if (expanded) {
                          return <b className="cursor-pointer bg-red-100 py-1 px-2.5 rounded-full text-danger">-</b>;
                        }
                        return <b className="cursor-pointer bg-blue-100 py-1 px-2 rounded-full text-primary">+</b>;
                      },
                      renderer: (datas) => DetailContent({ ...datas }),
                      // renderer: (datas) => DetailContent(updateData, setUpdateData, { ...datas }),
                    }}
                  />
                  <div className="flex justify-between items-center w-full">
                    <PaginationListStandalone {...paginationProps} />
                    <div className="flex justify-end">
                      <PaginationTotalStandalone {...paginationProps} />
                    </div>
                  </div>
                </div>
              )}
            </PaginationProvider>
          </div>
        )}
      </ToolkitProvider>
    </div>
  );
};

const DetailContent = ({ content, createdAt }) => (
  <div className="pb-2 px-14">
    <div className="text-sm text-333 leading-5 mb-3">
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </div>
    <p className="text-sm text-888">{createdAt}</p>
  </div>
);

export default Notice;
